module.exports = __webpack_public_path__ + "img/bh_21.cf364463.jpg";